import React from 'react';

import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Stack } from '@atlaskit/primitives/compiled/stack';

import { LoadingSkeleton } from '@townsquare/loading-skeleton';
import { YourAppsPageLoadingSkeleton } from '@townsquare/your-apps/full-page-skeleton';

export const AppsViewRedesignLoadingSkeleton = (): React.JSX.Element => {
	return (
		<Stack space="space.250">
			<Inline space="space.200" spread="space-between" alignBlock="center" shouldWrap>
				<LoadingSkeleton height="20px" width="80px" />

				<Inline space="space.100" alignBlock="center">
					<LoadingSkeleton height="32px" width="95px" />
					<LoadingSkeleton height="32px" width="200px" />
				</Inline>
			</Inline>
			<YourAppsPageLoadingSkeleton />
		</Stack>
	);
};
